import React, { useEffect } from 'react';
import { Prospect } from '../../shared/types';
import { advocaciaProcessos } from '../../shared/data/advocaciaData';
import { Scale, FileText, UploadCloud, Lock, Bell, ChevronRight, CheckCircle2, ShieldAlert } from 'lucide-react';

export const LawApp: React.FC<{ prospect: Prospect }> = ({ prospect }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const proc = advocaciaProcessos[0];

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4 font-sans text-slate-900">
      <div className="w-[390px] h-[844px] bg-[#F8FAFC] rounded-[2.5rem] relative overflow-hidden border-[12px] border-slate-800 flex flex-col justify-between">
        
        {/* Top Status */}
        <div>
           <div className="h-12 flex items-center justify-between px-8 text-xs font-medium pt-2 text-slate-600">
              <span>14:30</span>
              <div className="flex gap-1.5 items-center">
                 <div className="w-4 h-3 bg-current rounded-sm"></div>
                 <div className="w-3 h-3 bg-current rounded-full"></div>
              </div>
           </div>

           <div className="px-6 pt-2 pb-4">
              <div className="flex justify-between items-center mb-6">
                 <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-[#0F172A] text-[#C5A880] flex items-center justify-center font-black border border-slate-800">
                       <Scale className="w-5 h-5" />
                    </div>
                    <div>
                       <p className="text-[10px] text-slate-500 uppercase tracking-widest font-bold">Portal do Cliente</p>
                       <h1 className="font-heading font-bold text-sm text-[#0F172A]">{prospect.trade_name}</h1>
                    </div>
                 </div>
                 <div className="w-9 h-9 rounded-xl bg-slate-200 border border-slate-300 flex items-center justify-center text-slate-700">
                    <Bell className="w-4 h-4" />
                 </div>
              </div>

              {/* Card Processo em Destaque - STRICT NO SHADOWS */}
              <h3 className="font-heading font-bold text-xs uppercase tracking-wider text-slate-500 mb-3">Sua Ação em Andamento</h3>
              <div className="bg-[#0F172A] text-white p-5 rounded-xl mb-6 border border-slate-800">
                 <div className="flex justify-between items-start mb-3">
                    <span className="bg-[#C5A880] text-[#0F172A] px-2.5 py-0.5 rounded text-[10px] font-bold uppercase">{proc.status}</span>
                    <Lock className="w-4 h-4 text-slate-500" />
                 </div>
                 <h4 className="font-bold text-sm text-white mb-1 line-clamp-1">{proc.subject}</h4>
                 <p className="text-[10px] text-slate-400 font-mono mb-4">{proc.processNumber}</p>
                 
                 <div className="bg-slate-900/80 p-3 rounded-lg border border-slate-800 text-[11px] text-slate-300 leading-snug">
                    <p className="text-[#C5A880] font-bold mb-1">Última Movimentação:</p>
                    <p className="font-light">{proc.lastUpdate}</p>
                 </div>
              </div>

              {/* Ações Rápidas: Envio de Documentos */}
              <h3 className="font-heading font-bold text-xs uppercase tracking-wider text-slate-500 mb-3">Envio de Documentos (Criptografado)</h3>
              <div className="space-y-3">
                 <div className="bg-white border border-slate-200 p-4 rounded-xl flex items-center justify-between">
                    <div className="flex items-center gap-3">
                       <div className="w-9 h-9 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center text-[#0F172A]">
                          <FileText className="w-4 h-4" />
                       </div>
                       <div>
                          <h5 className="font-bold text-xs text-[#0F172A]">Procuração Assinada</h5>
                          <p className="text-[10px] text-emerald-600 font-medium">✓ Validado pelo Advogado</p>
                       </div>
                    </div>
                 </div>

                 <div className="bg-white border border-slate-200 p-4 rounded-xl flex items-center justify-between">
                    <div className="flex items-center gap-3">
                       <div className="w-9 h-9 rounded-lg bg-amber-50 border border-amber-200 flex items-center justify-center text-amber-700">
                          <UploadCloud className="w-4 h-4" />
                       </div>
                       <div>
                          <h5 className="font-bold text-xs text-[#0F172A]">Balanço Patrimonial 2025</h5>
                          <p className="text-[10px] text-amber-700 font-medium">Pendente de Upload</p>
                       </div>
                    </div>
                    <button className="bg-[#0F172A] text-white text-[10px] font-bold px-3 py-1.5 rounded-lg border border-slate-800">
                       Enviar
                    </button>
                 </div>
              </div>

           </div>
        </div>

        {/* Footer App */}
        <div className="p-6 bg-white border-t border-slate-200">
           <button className="w-full bg-[#0F172A] text-[#C5A880] py-3 rounded-xl font-bold text-xs uppercase tracking-wider border border-slate-800 flex items-center justify-center gap-2">
              Falar com o Advogado do Caso
           </button>
        </div>

      </div>
    </div>
  );
};
